module.exports = __webpack_public_path__ + "static/microphone-8194c78370597013111c51896c776385.png";